import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import Tile, { TileIcon, TileLabel, TileLabels, TileSubLabel } from '@/components/ui/Tile/Tile';
import kollelIcon from '@/assets/icons/supportGoals/jewish.svg';

/**
 * "ניהול כוללים" — the entry point to the kollels list (HAT-1446), sitting among the goals offered
 * for supporteds (a kollel groups existing supporteds, same audience as נתמכים) rather than as a
 * sidebar tab, matching how ProjectsEntryTile reaches the projects list. It shares its icon with
 * the plain "כולל" support goal, so the label and sub-label spell out that this is where a kollel
 * is set up - the office opened that goal instead when this tile just read "כוללים".
 */
const KollelsEntryTile = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { fundId: routeFundId } = useParams();

  return (
    <Tile onClick={() => navigate(`/${routeFundId}/support/goals/kollels`)}>
      <TileIcon src={kollelIcon} alt="" />
      <TileLabels>
        <TileLabel>{t('kollels.entryTile.label')}</TileLabel>
        <TileSubLabel text={t('kollels.entryTile.subLabel')} />
      </TileLabels>
    </Tile>
  );
};

export default KollelsEntryTile;
